export default function lastDate18YearsAgo () {
    const dataCorrente = new Date();
    const dataMeno18Anni =  new Date(dataCorrente.getFullYear() - 18, dataCorrente.getMonth(), dataCorrente.getDate());
    // console.log("Data di 18 anni fa:", dataMeno18Anni);
    return dataMeno18Anni;
}